import { AgrArticleDistanceTypeSelectQuery } from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { Select, SelectProps } from "@stenajs-webui/select";
import * as React from "react";
import { useMemo } from "react";

interface Props extends Omit<SelectProps<unknown>, "value" | "onChange"> {
  value?: string;
  onValueChange?: (value: string) => void;
}

const query = gql`
  query AgrArticleDistanceTypeSelect {
    productPrice {
      distanceType {
        all {
          id
          code
          description
        }
      }
    }
  }
`;

export const AgrArticleDistanceTypesSelect: React.FC<Props> = ({
  onValueChange,
  value,
  ...selectProps
}) => {
  const { data, loading } = useQuery<AgrArticleDistanceTypeSelectQuery>(query);

  const agrArticleDistanceTypes = useMemo(() => {
    return data?.productPrice.distanceType.all;
  }, [data]);

  const allOptions = useMemo(
    () =>
      agrArticleDistanceTypes
        ?.map((distanceType) => ({
          label: `${distanceType.description} (${distanceType.code})`,
          value: String(distanceType.code),
        }))
        .sort((a, b) => {
          return a.label.localeCompare(b.label);
        }),
    [agrArticleDistanceTypes]
  );

  const selected = useMemo(
    () => allOptions?.find((o) => o.value === value),
    [allOptions, value]
  );

  return (
    <Select
      isLoading={loading}
      options={allOptions}
      value={selected || null}
      onChange={(v: any) => {
        if (!v) {
          onValueChange?.("");
        } else if (onValueChange && v) {
          onValueChange?.(v.value);
        }
      }}
      placeholder={"Group"}
      {...selectProps}
    />
  );
};
